import * as angular from 'angular';
import * as dayjs from 'dayjs';
import { timer } from 'rxjs';

import { INgRedux } from '../redux';
import { BeforeUnloadService } from '../services/before-unload-service';
import * as fromStore from '../store';

interface ISessionState {
    warn: dayjs.Dayjs;
    logout: dayjs.Dayjs;
}

interface ISessionScope extends angular.IScope, ISessionState {
    route: string;
}

export class SessionController implements angular.IController {
    static readonly $inject = [
        '$scope',
        '$http',
        '$timeout',
        '$window',
        '$ngRedux',
        'fcBeforeUnloadService'
    ];

    constructor(
        private readonly scope: ISessionScope,
        private readonly http: angular.IHttpService,
        private readonly timeout: angular.ITimeoutService,
        private readonly window: angular.IWindowService,
        private readonly ngRedux: INgRedux,
        private readonly beforeUnloadService: BeforeUnloadService
    ) {
        this.mapState = this.mapState.bind(this);

        // Configure the redux state and action binding
        const connect = this.ngRedux.connect(this.mapState);
        const unsubscribe = connect(this.scope);

        this.scope.$on('$destroy', unsubscribe);
    }

    $onInit(): void {
        this.timeout(() => {
            const modal = angular.element('#fc-session-timeout-modal');

            // The session only needs to be tracked if there is a timeout modal to display
            if (modal.length > 0) {
                // Create an observable timer and subscribe to start it
                const start = new Date();
                const timeout = timer(1000, 1000);

                console.log(`Session: start [${start}]`);

                timeout.subscribe(() => {
                    const now = new Date();
                    const current = dayjs(now);

                    // If the session has expired, force a logout
                    if (current.isAfter(this.scope.logout)) {
                        console.log(`Session: logout [${now}]`);

                        this.beforeUnloadService.bypassWarning();
                        this.window.location.href = this.scope.route;
                    } else if (this.scope.warn) {
                        // If set, check if the warn timestamp has elapsed
                        if (current.isAfter(this.scope.warn)) {
                            console.log(`Session: warn [${now}]`);

                            // Clear the warn timestamp to prevent duplicate messages
                            this.scope.warn = null;

                            // Open the timeout message
                            modal.foundation('open');
                        }
                    }
                });

                // Watch for the modal close and call the server to extend the session expiry
                // Note that the http interceptor will trigger an update of the last activity
                modal.on('closed.zf.reveal', () => {
                    this.http.get('/Account/KeepAlive');
                });
            }
        });
    }

    private mapState(state: fromStore.ICoreState): ISessionState {
        const lastActivity = fromStore.getLastActivity(state);
        return {
            warn: dayjs(lastActivity).add(45, 'minute'),
            logout: dayjs(lastActivity).add(60, 'minute')
        };
    }
}
